import React from 'react';
import Content from './Content';

function Layout() {
    return (
        <div className="pageLayout">
            <Content />
        </div>
    )
};

export default Layout;
